<template>
  <b-modal
    id="editModal"
    ref="modal"
    :title="title"
    @hide="onHide"
    @cancel="onCancel"
    :visible="open"
    :ok-title="okTitle"
    :cancel-title="$t('general.cancel')"
    size="lg"
    @ok="saveModal"
    :ok-disabled="disabled"
    :static="true"
  >
    <component
      v-bind:is="renderModalForm"
      :save="saveAct"
      :data="modalProps"
      :changeVal="changeDisabled"
      :changeData="changeData"
      :saveState="saveState"
      :modalName="modalName"
      :modalEvent="modalEvent"
      :formName="form"
      :onComplete="onComplete"
    ></component>
  </b-modal>
</template>

<script>
import i18n from "@/plugins/i18n";
import AddComment from "./AddComment";
import AddFile from "./AddFile";
import AppointTicket from './AppointTicket'
import Report from './Report'
import SetState from './SetState.vue'
import ChangeState from './ChangeState.vue'
import Expired from './ExpiredSubs.vue'

export default {
  name: "TicketModal",
  data: function () {
    return {
      title: "",
      okTitle: i18n.t("general.add"),
      disabled: false,
      saveAct: false,
    };
  },
  props: {
    open: Boolean,
    modalEvent: Function,
    form: String,
    modalName: String,
    modalProps: Object,
    onComplete: Function,
  },
  components: {
    AddComment,
    AddFile,
    AppointTicket,
    Report,
    SetState,
    ChangeState,
    Expired
  },
  computed: {
    //Açılacak Modalı belirleme işlemleri
    renderModalForm: function () {
      if (this.modalName === "add") {
        this.title = i18n.t("ticket.comment.makeComment");
        this.okTitle = i18n.t("ticket.comment.makeComment");
        return 'AddComment';
      } else if (this.modalName === "add-file") {
        this.title = i18n.t("ticket.comment.addFile")
        this.okTitle = i18n.t("ticket.comment.addFile")
        return 'AddFile';
      } else if (this.modalName === 'appointment') {
        this.title = i18n.t("ticket.detail.assign")
        this.okTitle = i18n.t("ticket.detail.assign")
        return 'AppointTicket';
      } else if (this.modalName === 'report') {
        this.title = 'Rapor Al'
        this.okTitle = 'Raporu Al'
        return 'Report'
      } else if (this.modalName == 'state') {
        this.title = 'Durum Değiştir'
        this.okTitle = 'Uygula'
        return 'SetState'
      }  else if (this.modalName == 'changeState') {
        this.title = 'Durum Değiştir'
        this.okTitle = 'Değiştir'
        return 'ChangeState'
      } else if (this.modalName == 'expired') {
        this.title = 'Dikkat'
        this.okTitle = 'Anladım'
        return 'Expired'
      } else {
        return null
      }
    },
  },
  watch: {
    saveAct() {
      return false;
    },
  },
  methods: {
    // Modal tamamlandığı zaman olacak event
    onHide: function () {
      if (!this.saveAct) this.modalEvent(false);
    },
    onCancel: function () {
      this.saveState(false);
      if (!this.saveAct) this.modalEvent(false);
    },
    saveState: function (val) {
      this.saveAct = val;
    },
    // Modal tamamlandığı zaman olacak event
    saveModal: async function (bvModalEvt) {
      bvModalEvt.preventDefault();
      // Modalın içerisindeki watchı tetikler
      this.saveState(true);
    },
    changeData(val, name) {
      this.modalProps[name] = val;
    },
    changeDisabled(val) {
      if (val == this.modalProps.name) this.disabled = false;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/pages/Support/Ticket/modals/index.vue